module.exports = __webpack_public_path__ + "img/public/siteImages/forgotCarBg.png?41df7f81";